import { render } from "./MStarsInput.vue?vue&type=template&id=2e07f972"
import script from "./MStarsInput.vue?vue&type=script&lang=js"
export * from "./MStarsInput.vue?vue&type=script&lang=js"

import "./MStarsInput.vue?vue&type=style&index=0&id=2e07f972&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__